import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileSpreadsheet } from 'lucide-react';

import { useAuth } from '../../context/AuthContext';
import { Button } from '../ui/button';

/**
 * « Importer (Excel) » : réservé à l'administrateur de la société (sur ses pages
 * Camions et Chauffeurs) et au super administrateur (depuis la fiche d'une
 * société, qui passe `organizationId`). N'affiche rien aux autres, ni hors d'une
 * session.
 */
const BoutonImportExcel = ({ organizationId }) => {
  let auth = null;
  try {
    // L'appel a lieu à chaque rendu, dans le même ordre : seule son erreur est rattrapée.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    auth = useAuth();
  } catch (erreur) {
    // Hors d'une session (page rendue seule): aucun bouton.
  }
  const navigate = useNavigate();
  const role = auth?.user?.role;
  const visible = organizationId ? role === 'SUPER_ADMIN' : role === 'ADMIN_SOCIETE';
  if (!visible) return null;
  return (
    <Button
      type="button"
      variant="outline"
      onClick={() => navigate(organizationId ? `/organizations/${organizationId}/fleet-import` : '/fleet-import')}
      data-testid="import-excel-btn"
    >
      <FileSpreadsheet className="h-4 w-4" aria-hidden="true" />
      Importer (Excel)
    </Button>
  );
};

export default BoutonImportExcel;
